import { combineReducers } from 'redux';
import RecordingAdd from './add.reducer';
import Recording from './recording.reducer';
import RecordingSerieAdd from './addSerie.reducer';
import RecordingDelete from './delete.reducer';
import RecordingSeriesList from './seriesList.reducer';
import RecordingDeleteSerie from './deleteSerie.reducer';
import RecordingList from './recordingList.reducers'

export default combineReducers({
  RecordingAdd,
  Recording,
  RecordingSerieAdd,
  RecordingDelete,
  RecordingDeleteSerie,
  RecordingSeriesList,
  RecordingList
});
